import {Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MediumDTO, ThumbnailSize} from '../../services/api/api';
import {TranslateService} from '@ngx-translate/core';
import {UtilService} from '../../services/util.service';
import {MediumViewerComponent} from '../controls/medium-viewer/medium-viewer.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'sb-comp-medium',
  templateUrl: './sb-medium.component.html',
  styleUrls: ['./sb-medium.component.scss'],
  standalone: false,
})
export class SbMediumComponent implements OnInit {
  @ViewChild('videoElement') videoElement: HTMLVideoElement;

  @Input() medium: MediumDTO;
  @Input() thumbnailSize: string = ThumbnailSize.M;
  @Input() hoverPreview: boolean = false;
  @Input() showFullOnClick: boolean = false;
  @Input() still: boolean = false;
  @Input() title: boolean = false;
  @Input() controls: boolean = false;
  @Input() muted: boolean = true;
  @Input() classes: string = '';
  @Input() background: boolean = false;
  @Input() hoverPlacement: string = '';

  @Output() videoEnded = new EventEmitter();

  // tslint:disable-next-line:variable-name
  _customHeight: string;
  @Input() set customHeight(val: string) {
    if (val) {
      this._customHeight = val;
    }
  }

  get customHeight(): string {
    return this._customHeight;
  }

  // tslint:disable-next-line:variable-name
  _customWidth: string;
  @Input() set customWidth(val: string) {
    if (val) {
      this._customWidth = val;
    }
  }

  get customWidth(): string {
    return this._customWidth;
  }

  hovered: boolean;

  @HostListener('click', ['$event'])
  onClick($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.onDoubleClick();
  }

  constructor(
    public translate: TranslateService,
    public util: UtilService,
    private modal: NgbModal,
    private sanitizer: DomSanitizer
  ) {
    this.hovered = false;
    this._customWidth = '70px';
    this._customHeight = '70px';
  }

  ngOnInit(): void {
    /*
    if (this.width && !this.height) {
      this.height = this.width;
    }
    if (!this.width && this.height) {
      this.width = this.height;
    }
    if (this.width && this.height && !this.thumbnailSize) {
      const greaterValue: number = this.width > this.height ? this.width : this.height;
      switch (true) {
        case greaterValue <= 120:
          this.thumbnailSize = ThumbnailSize.XS;
          break;
        case greaterValue <= 240:
          this.thumbnailSize = ThumbnailSize.S;
          break;
        case greaterValue <= 480:
          this.thumbnailSize = ThumbnailSize.M;
          break;
        case greaterValue <= 960:
          this.thumbnailSize = ThumbnailSize.L;
          break;
        case greaterValue <= 1920:
          this.thumbnailSize = ThumbnailSize.XL;
          break;
      }
    }
    if (this.thumbnailSize && !this.width && !this.height) {
      switch (this.thumbnailSize) {
        case 'XS':
          this.height = 120;
          this.width = 120;
          break;
        case 'S':
          this.height = 240;
          this.width = 240;
          break;
        case 'M':
          this.height = 480;
          this.width = 480;
          break;
        case 'L':
          this.height = 960;
          this.width = 960;
          break;
        case 'Xl':
          this.height = 1920;
          this.width = 1920;
          break;
      }
    }

    if (!this.width && !this.height && !this.thumbnailSize) {
      this.width = 70;
      this.height = 70;
      this.thumbnailSize = ThumbnailSize.XS;
    }
     */
  }

  url(medium: MediumDTO): string {
    let path = null;
    if (medium && medium.url) {
      path = this.util.appendQueryParamToUrl(medium.url as unknown as string, 'thumbnail=' + this.thumbnailSize);
    }
    return path;
  }

  onDoubleClick() {
    if (this.showFullOnClick) {
      if (this.medium && this.medium.id) {
        const modal = this.modal.open(MediumViewerComponent, { size: 'lg' });
        (modal.componentInstance as MediumViewerComponent).medium = this.medium;
        (modal.componentInstance as MediumViewerComponent).modalRef = modal;
      }
    }
  }

  backgroundURL(medium: MediumDTO) {
    let path = null;
    if (medium && medium.stillImage) {
      path = this.sanitizer.bypassSecurityTrustStyle(
        'url(' + this.util.appendQueryParamToUrl(medium.stillImage as unknown as string, 'thumbnail=' + this.thumbnailSize) + ')'
      );
    }
    return path;
  }

  mediaInfos() {
    let ret = '';
    if (this.medium) {
      if (this.medium.name) {
        ret += '\nName: ' + this.medium.name;
      }
      if (this.medium.resolution) {
        ret += '\nAuflösung: ' + this.medium.resolution.width + 'x' + this.medium.resolution.height + 'px';
      }
      if (this.medium.duration) {
        ret += '\nDauer: ' + ((this.medium.duration * 10.0) / 10.0).toFixed(1) + ' Sek.';
      }
      if (this.medium.format) {
        if (this.medium.format.videoCodec) {
          ret += '\nVideo Codec: ' + this.medium.format.videoCodec;
        }
        if (this.medium.format.audioCodec) {
          ret += '\nAudio Codec: ' + this.medium.format.audioCodec;
        }
      }
      if (this.medium.size) {
        let size = this.medium.size;
        let kb = false;
        if (size > 1024) {
          size = size / 1024;
          kb = true;
        }
        let mb = false;
        if (size > 1024) {
          size = size / 1024;
          mb = true;
        }
        ret += '\nGröße: ' + size.toFixed(kb || mb ? 1 : 0) + ' ' + (mb ? 'MB' : kb ? 'KB' : 'Byte' + (size === 1 ? '' : 's'));
      }
      if (this.medium.id) {
        ret += '\nMedium ID: ' + this.medium.id;
      }
      return ret.length ? ret.substr(1) : ret;
    }
    return '';
  }
}
